import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { RiChat3Line } from 'react-icons/ri';
import { useTranslation } from 'services/localization';

const RentalCardCommentStatus = () => {
	const classes = useStyles();
	const { t } = useTranslation();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<Box className={classes.container}>
			<RiChat3Line className={classes.commentIcon} size={18} />
			{!isMobile && (
				<Typography className={classes.commentLabel} variant="body2">
					{t('common:form.comment')}
				</Typography>
			)}
		</Box>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		commentLabel: {
			fontWeight: 500,
		},
		commentIcon: {
			marginRight: theme.spacing(0.5),
		},
		container: {
			background: theme.palette.background.secondary,
			padding: theme.spacing(1),
			display: 'flex',
			marginLeft: theme.spacing(0.5),
		},
	}),
);

export default RentalCardCommentStatus;
